import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaInstagram, FaFacebookF, FaTiktok } from 'react-icons/fa';
import logo from '../assets/logo.png';

const Header = () => {
    const location = useLocation();

    const isActive = (path) => {
        return location.pathname === path ? 'active' : '';
    };

    return (
        <header>
            {/* Upper Header */}
            <div className="bg-dark-green text-white py-2 upper-header">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6 d-flex align-items-center mb-2 mb-md-0 justify-content-center justify-content-md-start mobile-hidden">
                            <FaMapMarkerAlt className="text-yellow-icon me-2" />
                            <span>2 Queen Anne's Place, Bush Hill Park, Enfield, EN1 2PX</span>
                        </div>
                        <div className="col-md-6 d-flex align-items-center justify-content-between justify-content-md-end gap-3 flex-wrap">
                            <div className="d-flex align-items-center">
                                <FaPhoneAlt className="text-yellow-icon me-2" />
                                <span>020 3770 9599</span>
                            </div>
                            <div className="d-flex align-items-center mobile-hidden">
                                <FaEnvelope className="text-orange-icon me-2" />
                                <span>info@zubisnursery.com</span>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <a target='_blank' href="https://www.instagram.com/zubis_nursery" className="text-white"><FaInstagram /></a>
                                <a target='_blank' href="https://www.facebook.com/share/17dZDEp8up/?mibextid=wwXIfr" className="text-white"><FaFacebookF /></a>
                                <a target='_blank' href="https://www.tiktok.com/@zubisnursery?lang=en" className="text-white"><FaTiktok /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Header */}
            <nav className="navbar navbar-expand-lg bg-cream sticky-top shadow-sm">
                <div className="container">
                    <Link className="navbar-brand" to="/">
                        <img src={logo} alt="Zubis Nursery" />
                    </Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav mx-auto mb-2 mb-lg-0 align-items-center">
                            <li className="nav-item mx-2">
                                <Link className={`nav-link nav-link-custom ${isActive('/')}`} to="/">Home</Link>
                            </li>
                            <li className="nav-item mx-2">
                                <Link className={`nav-link nav-link-custom ${isActive('/about')}`} to="/about">About Us</Link>
                            </li>
                            <li className="nav-item mx-2">
                                <Link className={`nav-link nav-link-custom ${isActive('/curriculum')}`} to="/curriculum">Curriculum</Link>
                            </li>
                            <li className="nav-item mx-2">
                                <Link className={`nav-link nav-link-custom ${isActive('/healthy-eating')}`} to="/healthy-eating">Healthy Eating</Link>
                            </li>
                            <li className="nav-item mx-2">
                                <Link className={`nav-link nav-link-custom ${isActive('/admission')}`} to="/admission">Admissions & Fees</Link>
                            </li>
                        </ul>
                        <div className="d-flex justify-content-center">
                            <Link to="/contact" className="btn btn-contact text-decoration-none">Contact Us</Link>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default Header;
